import { VolumeIcon } from '@mote/assets/icons'
import { Block, IconButton, Spinner } from '@mote/ui'
import styled from '@xstyled/styled-components'
import { Control } from '../../shared/components'

const buttonSize = 24
const buttonSpacing = { marginRight: 11 }

export const StyledSpinner = styled(Spinner).attrs({
  radius: buttonSize
})(buttonSpacing)

interface ErrorControlProps {
  onClick: () => void
}

export const ErrorControl = styled(Control).attrs({
  tooltipProps: { disabled: true },
  size: buttonSize
})<ErrorControlProps>(buttonSpacing)

export const StyledIconButton = styled(IconButton).attrs({
  icon: <VolumeIcon />,
  size: buttonSize
})(buttonSpacing, {
  color: 'black',
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: 'transparent'
  },
  '&:focus': {
    boxShadow: 'none'
  }
})

export interface PlayToteButtonWrapperProps {
  spacing?: 'bottom'
}

export const PlayToteButtonWrapper = styled(Block).attrs({
  layout: 'horizontal',
  align: 'center'
})<PlayToteButtonWrapperProps>(props =>
  props.spacing === 'bottom'
    ? {
        marginBottom: 14
      }
    : undefined
)
